"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamsListDataDto = instanceOfTeamsListDataDto;
exports.TeamsListDataDtoFromJSON = TeamsListDataDtoFromJSON;
exports.TeamsListDataDtoFromJSONTyped = TeamsListDataDtoFromJSONTyped;
exports.TeamsListDataDtoToJSON = TeamsListDataDtoToJSON;
exports.TeamsListDataDtoToJSONTyped = TeamsListDataDtoToJSONTyped;
/**
 * Check if a given object implements the TeamsListDataDto interface.
 */
function instanceOfTeamsListDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('leagueId' in value) || value['leagueId'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('countryId' in value) || value['countryId'] === undefined)
        return false;
    return true;
}
function TeamsListDataDtoFromJSON(json) {
    return TeamsListDataDtoFromJSONTyped(json, false);
}
function TeamsListDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'leagueId': json['leagueId'],
        'code': json['code'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'countryId': json['countryId'],
        'city': json['city'] == null ? undefined : json['city'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}
function TeamsListDataDtoToJSON(json) {
    return TeamsListDataDtoToJSONTyped(json, false);
}
function TeamsListDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'leagueId': value['leagueId'],
        'code': value['code'],
        'name': value['name'],
        'shortName': value['shortName'],
        'countryId': value['countryId'],
        'city': value['city'],
        'logoUrl': value['logoUrl'],
    };
}
